<template>
    <section v-if="post" class="section lightbg-panel">
        <div class="columns is-desktop mb-40">
            <div class="column">
                <div class="rel"><div class="f-ribbon"><span>Piši nam</span></div></div>
                <app-contact-form></app-contact-form>
            </div>

            <div class="column">
                <div class="post-content boxs">
                    <h3 class="is-4"> <a :href="post.link">{{ post.title }}</a> </h3>
                    <div v-html="post.content"></div>
                    <a class="general-link" href="/blog">Vsi članki</a>
                </div>
            </div>


        </div>
    </section>
</template>

<script>
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import ContactForm from '../elements/form/ContactForm';
import Modal from '../layout/Modal.vue';
import ModalMixin from '../../mixins/ModalMixin';

export default {
    name: 'app-action-call-socials',
    props: [/*'testimonials',*/ 'post', 'zeroPadding'],
    mixins: [ModalMixin],
    components: {
        'app-modal': Modal,
        'app-contact-form': ContactForm,
        Scrolly,
        ScrollyViewport,
        ScrollyBar
    },
    computed: {
        classObj() {
            if (this.zeroPadding !== undefined) {
                return ' padding0';
            } else {
                return ' padding30';
            }
        },
    },
    data() {
        return {
            //
        };
    },

}
</script>

<style lang="scss" scoped>
// @import "../../style/variables";
// @import "../../style/cafooter";
.scroll-me {
    width: 100%;
    height: 460px;
    .scrolly-viewport {
        background: #ddd;
        border: 1px solid #d0d0d0;
        border-radius: 5px;
        padding: 50px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/complex/CaFooter.vue